import React from 'react';

const AIProcessingOverlay = ({ isVisible, message }) => {
  if (!isVisible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{ backgroundColor: 'rgba(0,0,0,0.65)' }}
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className="bg-card border border-border rounded-2xl shadow-elevation-lg p-8 mx-4 max-w-sm w-full text-center">
        {/* Spinning icon */}
        <div className="flex justify-center mb-5">
          <div className="relative w-16 h-16">
            <div className="absolute inset-0 rounded-full border-4 border-primary/20" />
            <div className="absolute inset-0 rounded-full border-4 border-primary border-t-transparent animate-spin" />
          </div>
        </div>

        <h2 className="text-lg font-bold text-foreground mb-2">
          AI is Processing Your Data
        </h2>

        <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
          {message || 'Please do not click any buttons or navigate away. This may take a minute.'}
        </p>

        {/* Warning strip */}
        <div className="flex items-center gap-2 px-4 py-3 rounded-lg bg-warning/10 border border-warning/30">
          <svg
            className="w-4 h-4 text-warning flex-shrink-0"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
            />
          </svg>
          <span className="text-xs font-semibold text-warning">
            Do NOT press any buttons — just wait
          </span>
        </div>
      </div>
    </div>
  );
};

export default AIProcessingOverlay;
